module.exports = "/packs/visa-b6120b069ebaefa768a04e5218889d58.png";